import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import router from './router';
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import store from './store'; // Importa tu archivo store.js
import moment from 'moment';
import VueMask from 'v-mask'
Vue.use(VueMask);

import 'driver.js/dist/driver.css';


Vue.prototype.moment = moment;

// Crear el Event Bus y añadirlo al prototipo de Vue
Vue.prototype.$eventBus = new Vue();


import './mixins/valitators';
Vue.use(Vuesax, {})
Vue.use(VueRouter);

Vue.config.productionTip = false;


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');